import axios from 'axios'
import { getAuthHeader } from '../../utils';

export const v1_voucher_report = async (payload) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v1/voucher/report`;
    return axios.post(url, payload, getAuthHeader()).then((res) => {
        return res.data;
    })
}
